import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';

export default class TeamList {
    constructor($el) {
        this.$el = $el;
        this.$swiper = this.$el.querySelector('[data-team-list-slider-items]');

        this.initSlider = this.initSlider.bind(this);

        this.initSlider();
    }

    initSlider() {
        new Swiper(this.$swiper, {
            spaceBetween: 24,
            slidesPerView: 1.1,
            // autoplay: { delay: 4000, },
            navigation: {
                nextEl: this.$el.querySelector(".swiper-next"),
                prevEl: this.$el.querySelector(".swiper-prev"),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                },
                992: {
                    slidesPerView: 2.2,
                },
                1200: {
                    slidesPerView: 3.3,
                }
            }
        });
    }
}